const isPngDataUrl = (value) => (
  typeof value === 'string'
  && value.startsWith('data:image/png;base64,')
  && value.length > 200
);

export const getFormDIDecaQr = (dataForm) => (
  dataForm?.decaQrDataUrl
  || dataForm?.deca_qr_data_url
  || dataForm?.decaQr
  || dataForm?.deca_qr
  || ''
);

export const drawFormDIDecaQr = (doc, qrImage) => {
  if (isPngDataUrl(qrImage)) {
    doc.addImage(qrImage, 'PNG', 500, 10, 54, 54);
  }
};

export const drawFormDIHeader = (doc, qrImage) => {
  const hasQr = isPngDataUrl(qrImage);
  const textLeft = 40;
  const textWidth = hasQr ? 430 : 515;
  const textCenter = textLeft + (textWidth / 2);
  const qrX = 500;
  const qrY = 10;
  const qrSize = 54;

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9.5);
  doc.text(
    'DOCUMENTO DE IDENTIFICACIÓN DE RESIDUOS SIN NOTIFICACIÓN PREVIA',
    textCenter,
    29,
    { align: 'center', maxWidth: textWidth },
  );

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(6.5);
  const legalText = '(Artículo 6.1 y Anexo III del RD 553/2020, de 2 de junio, por lo que se regula el traslado de residuos en el interior del territorio del Estado. BOE. nº 171 del 19/07/2020)';
  const legalLines = doc.splitTextToSize(legalText, textWidth);
  doc.text(legalLines, textCenter, 42, { align: 'center', lineHeightFactor: 1.15 });

  if (hasQr) {
    doc.addImage(qrImage, 'PNG', qrX, qrY, qrSize, qrSize);
  }
};
